<template>
  <div class="group-cpm">
    <div
    v-if="isAdmin"
    class="group-cpm__elements pointer">
      <span class="group-cpm__text group-cpm__text">
        {{ getPriceCpm }}
      </span>
      <span
      v-if="!hideDetails"
      class="group-cpm__text group-cpm__text_light">
        {{ getClientCpm }}
      </span>
    </div>
    <span
    v-else
    class="group-cpm__text">
      {{ cpm ? cpm : '—' }}
    </span>

    <transition name="fade">
      <div
      v-if="false"
      v-click-outside="onClickOutside"
      class="group-cpm__editor">
        <div class="group-cpm__editor-element">
          <span class="group-cpm__text_light">
            {{ $t('Edit a CPM') }}
          </span>
          <input
          v-model="cpmValue"
          type="text"
          :placeholder="$t('Specify the CPM')"
          class="group-cpm__input">
        </div>
        <DataButton
        :text="$t('save')"
        type="text"
        @handler="saveChanges" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GroupCpm',
  props: {
    hideDetails: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: null,
    },
    cpm: {
      type: [String, Number],
      default: null,
    },
    cpmFromBuy: {
      type: [String, Number],
      default: null,
    },
    disableEditor: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showEditor: false,
  }),
  methods: {
    openEditor() {
      if (!this.isAdmin || this.disableEditor) return;

      this.cpmValue = this.cpm;
      this.showEditor = true;
    },
    closeEditor() {
      this.showEditor = false;
      this.cpmValue = null;
    },
    onClickOutside() {
      this.closeEditor();
    },
    saveChanges() {
      const newData = {
        cpm: this.cpmValue === '' ? null : this.cpmValue,
      };

      this.showEditor = false;

      this.$store.dispatch('groups/groupUpdate', { id: this.group.id, social: this.group.social, newData })
        .then(() => {
          this.group.cpm = this.cpmValue === '' ? null : this.cpmValue;
          this.$store.dispatch('app/setSnackBar', { text: this.$t('Data updated'), error: false });
        });
    },
  },
  computed: {
    getClientCpm() {
      // NEED TRANSLATE
      return `CPM Клиент: ${this.cpm ? this.cpm : '—'}`;
    },
    getPriceCpm() {
      // NEED TRANSLATE
      return `CPM Прайс: ${this.cpmFromBuy ? this.cpmFromBuy : '—'}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.group-cpm {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 180px;
  min-height: 50px;
  position: relative;
}

.group-cpm__elements {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @include between-elements {
    margin-bottom: 5px;
  }
  &_row {
    flex-direction: row;
    margin-bottom: 0px;
  }
}

.group-cpm__text {
  font-size: 12px;
  color: $primary-gray;
  text-align: center;
  word-break: break-all;
  &_small {
    font-size: 12px;
  }
  &_light {
    font-size: 12px;
    color: $primary-lightgray;
  }
}

.group-cpm__editor {
  position: absolute;
  top: 0px;
  left: 30px;
  min-width: 200px;
  border-radius: 12px;
  padding: 20px 20px 0px;
  box-shadow: 0px 0px 10px 1px rgb(34 60 80 / 10%);
  background: $primary-white;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include between-elements {
    margin-bottom: 10px;
  }
}

.group-cpm__editor-element {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include between-elements {
    margin-bottom: 5px;
  }
}

.group-cpm__input {
  padding: 5px 10px;
  border: 1px solid $primary-lightgray;
  border-radius: 8px;
  font-size: 12px;
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-size: 12px;
    color: $primary-lightgray;
  }
}

</style>
